<!--
 * @Author: 陈乾
 * @Date: 2022-03-23 11:27:03
 * @LastEditors: 陈乾
 * @LastEditTime: 2025-09-19 15:00:50
 * @Description: file content
 * @FilePath: /Cheers 上线速览/src/App.vue
-->
<template>
  <div id="app">
    <router-view />
    <loading />
  </div>
</template>

<script>
import loading from '@/components/loading/loading'

export default {
  components: {
    loading
  },
  data() {
    return {}
  }
}
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
